/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {ContextNodeWithFullContextViewer} from "../../../Components/Common/ContextNodeWithFullContextViewer";
import React from "react";

export function ContextNodeFieldViewer(props) {

	const {
		Value,
		RootData,
	} = props;

	return <span>
            <ContextNodeWithFullContextViewer
	            contextNodeId={Value}
	            userRoleId={RootData.userRoleId}
            />
        </span>;
}
